import { jsx as e, jsxs as s } from "react/jsx-runtime";
import * as o from "react";
import { cva as f } from "class-variance-authority";
import { AlertCircle as b, AlertTriangle as g, CheckCircle as x, Info as i, X as u } from "lucide-react";
import { cn as t } from "../../../lib/utils.js";
import { motion as h } from "framer-motion";
const w = f("relative w-full rounded-xl border p-4 transition-all duration-300", {
  variants: {
    variant: {
      default: "bg-bg-surface border-border-color text-text-primary shadow-subtle",
      info: "bg-lpr-teal/10 border-lpr-teal/60 text-lpr-teal dark:border-lpr-aqua dark:text-lpr-aqua shadow-subtle",
      success: "bg-lpr-green/10 border-lpr-green/80 text-lpr-green",
      warning: "bg-lpr-gold/10 border-lpr-gold/60 text-lpr-charcoal dark:text-lpr-gold",
      error: "bg-lpr-red/10 border-lpr-red/60 text-lpr-red"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), N = o.forwardRef(({ className: l, variant: r = "default", onClose: a, children: d, ...c }, n) => {
  const p = {
    default: e(i, { className: "h-5 w-5" }),
    info: e(i, { className: "h-5 w-5" }),
    success: e(x, { className: "h-5 w-5" }),
    warning: e(g, { className: "h-5 w-5" }),
    error: e(b, { className: "h-5 w-5" })
  }, m = {
    default: "shadow-subtle",
    info: "shadow-[0_0_20px_rgba(27,67,50,0.1)]",
    success: "shadow-[0_0_20px_rgba(102,187,106,0.1)]",
    warning: "shadow-[0_0_20px_rgba(197,160,89,0.15)]",
    error: "shadow-[0_0_20px_rgba(176,90,71,0.15)]"
  };
  return s(h.div, { ref: n, initial: { opacity: 0, x: 20, scale: 0.95 }, animate: { opacity: 1, x: 0, scale: 1 }, exit: { opacity: 0, scale: 0.95 }, transition: { type: "spring", stiffness: 400, damping: 30 }, role: "alert", className: t(w({ variant: r }), m[r || "default"], "rounded-2xl border-color/5 overflow-hidden backdrop-blur-md", l), ...c, children: [s("div", { className: "flex items-start gap-4 relative z-10", children: [e("div", { className: "flex-shrink-0 mt-0.5 opacity-80", children: p[r || "default"] }), e("div", { className: "flex-1", children: d }), a && e("button", { onClick: a, className: "flex-shrink-0 rounded-full p-1 opacity-40 transition-all hover:opacity-100 hover:bg-black/5 active:scale-90", children: e(u, { className: "h-4 w-4" }) })] }), e("div", { className: t("absolute left-0 top-0 bottom-0 w-1 opacity-40", r === "info" && "bg-lpr-teal", r === "success" && "bg-lpr-green", r === "warning" && "bg-lpr-gold", r === "error" && "bg-lpr-red") })] });
});
N.displayName = "Alert";
const y = o.forwardRef(({ className: l, ...r }, a) => e("h5", { ref: a, className: t("mb-1 text-sm font-semibold text-text-primary leading-none", l), ...r }));
y.displayName = "AlertTitle";
const _ = o.forwardRef(({ className: l, ...r }, a) => e("div", { ref: a, className: t("text-sm font-medium leading-relaxed italic text-text-secondary/80", l), ...r }));
_.displayName = "AlertDescription";
export {
  N as Alert,
  _ as AlertDescription,
  y as AlertTitle
};
//# sourceMappingURL=Alert.js.map
